export default {
  title: '選擇碼批次',
};
